import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=b321c192&scoped=true"
import script from "./BaseForm.vue?vue&type=script&lang=ts"
export * from "./BaseForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b321c192",
  null
  
)

export default component.exports